module.exports = __webpack_public_path__ + "media/pm_banner.848b7b89.mp4";